<template>
  <div>
    <div class="modal-card" v-show="!isLoading">
      <header class="modal-card-head">
        <p class="modal-card-title">Detalii furnizor</p>
      </header>
      <section class="modal-card-body">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Nume</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control is-expanded">
                <input
                  class="input"
                  type="text"
                  placeholder="Nume furnizor"
                  v-model="provider.name"
                  autofocus
                >
              </p>
              <p
                class="help is-danger"
                v-if="$v.provider.name.$dirty && !$v.provider.name.required"
              >Camp obligatoriu.</p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">CUI</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control is-expanded">
                <input
                  class="input"
                  type="text"
                  placeholder="RO12345678"
                  v-model="provider.cui"
                >
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Adresa</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control is-expanded">
                <input
                  class="input"
                  type="text"
                  placeholder="Str. Exemplu, Nr. 1, Bucuresti"
                  v-model="provider.address"
                >
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Telefon</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control is-expanded">
                <input
                  class="input"
                  type="tel"
                  placeholder="0712345678"
                  v-model="provider.phone"
                >
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Email</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control is-expanded">
                <input
                  class="input"
                  type="email"
                  placeholder="contact@furnizor.ro"
                  v-model="provider.email"
                >
              </p>
              <p
                class="help is-danger"
                v-if="$v.provider.email.$dirty && !$v.provider.email.email"
              >Email invalid (nume@domeniu.ro).</p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Observatii</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control">
                <textarea
                  class="textarea"
                  placeholder="Informatii suplimentare despre furnizor"
                  v-model="provider.comments"
                ></textarea>
              </p>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Renunta</button>
        <button class="button is-primary" :class="{'is-loading':isSaving}" @click.prevent="submit">
          <span class="icon is-small">
            <i class="fa fa-save"></i>
          </span>
          <span>Salveaza</span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import LoadingInfo from "@/components/LoadingInfo";

import { EventBus } from "@/event-bus.js";

export default {
  name: "ProviderForm",
  props: ['providerId', 'reload', 'initialName'],
  components: { LoadingInfo },
  computed: {
    ...mapGetters(["isLoading"])
  },
  data: function () {
    return {
      isSaving: false,
      provider: {
        id: null,
        name: "",
        cui: "",
        address: "",
        phone: "",
        email: "",
        comments: ""
      }
    };
  },
  validations: {
    provider: {
      name: { required },
      email: { email }
    }
  },
  methods: {
    ...mapActions([
      "saveProvider",
      "loadProviders",
      "loadProvider"
    ]),
    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isSaving = !this.isSaving;
        this.saveProvider(this.provider)
          .then(resp => {
            // Transmite furnizorul salvat (cu id-ul de la server) către callback
            const savedProvider = resp.data || this.provider;
            if (this.reload)
              this.reload(savedProvider);
            this.$parent.close();
            this.isSaving = !this.isSaving;
            EventBus.$emit("reload-data");
          })
          .catch(err => {
            this.isSaving = !this.isSaving;
            console.error(err);
          });
      }
    },
    load(id) {
      this.loadProvider(id)
        .then(resp => {
          this.provider = resp.data;
        })
        .catch(err => console.log("error loading provider:", err));
    }
  },
  mounted() {
    var vid = this.providerId;
    if (vid > 0) {
      this.load(vid);
    } else if (this.initialName) {
      // Preia numele din câmpul de căutare pentru furnizor nou
      this.provider.name = this.initialName;
    }
  }
};
</script>

